import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromUser from '../_reducers/user.reducer';
import {UserState} from '../_reducers/user.reducer';

export const selectUserState = createFeatureSelector(fromUser.userFeatureKey);
export const selectLoggedUser = createSelector(selectUserState, (state: UserState) => state.loggedUser);
export const selectAuthorUser = createSelector(selectUserState, (state: UserState) => state.loggedUserAuthor);
export const selectVersionStatus = createSelector(selectUserState, (state: UserState) => state.latestVersion);
export const selectAdminUser = createSelector(selectUserState, (state: UserState) => state.admin);
export const selectLogout = createSelector(selectUserState, (state: UserState) => state.logout);
export const selectTokenRefreshing = createSelector(selectUserState, (state: UserState) => state.tokenRefreshing);
export const selectLoginStatus = createSelector(selectUserState, (state: UserState) => state.loggedUser !== null);
export const selectLogoutAfterEntrySave = createSelector(selectUserState, (state: UserState) => state.logoutAfterEntrySave);
export const selectJasminEnabled = createSelector(selectUserState, (state: UserState) => state.loggedUser?.jasminEnabled ?? false);

